import { render, staticRenderFns } from "./CampaignsTabs.vue?vue&type=template&id=3a455626&scoped=true"
import script from "./CampaignsTabs.vue?vue&type=script&lang=ts"
export * from "./CampaignsTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a455626",
  null
  
)

export default component.exports